import { useState } from 'react';
import { Box } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { StartConfiguration, WizardConfiguration } from '../components';
import { INTERNAL_STEPPER } from '../constants';

export const LearningFirstConfiguration = () => {
  const [stepper, setStepper] = useState(INTERNAL_STEPPER.START);
  const { styleResponsive } = useResponsiveStyle();

  return (
    <Box
      display='flex'
      flexDirection='column'
      maxWidth='1400px'
      mx='auto'
      px={styleResponsive({
        breakPoints: { desktop: 'huge' },
        defaultValue: 'none',
      })}
    >
      {stepper === INTERNAL_STEPPER.START && (
        <StartConfiguration.Learning setStepper={setStepper} />
      )}
      {stepper === INTERNAL_STEPPER.CONFIGURATION && (
        <WizardConfiguration.Learning setStepper={setStepper} />
      )}
    </Box>
  );
};
